<template>
  <!--资讯模块-->
  <div class="symc2_box">
    <div class="symc2_box_title"><img src="../assets/img/secondary_h3_pic.gif" width="21" height="15" /><a href="javascript:;">{{consultName}}</a></div>
    <div class="symc2_box_main">
      <ul>
        <li v-for="(item,index) in newsList" :key="item.id"  v-if="(settings.isSubject  && index>0 ) || !settings.isSubject">
          <router-link target="_blank" :to="{ path: '/newsInfo', query: { id: item.id }}" :title="item.newsTitle">{{item.newsTitle}}</router-link><span>{{$moment(item.publishTime).format('YYYY-MM-DD') }}</span>
        </li>
      </ul>
    </div>
    <div class="new_num_list" id="coursePageUl">
      <el-pagination
        small="true"
        @current-change="handleCurrentChange"
        :current-page.sync="pageNum"
        :page-size="pageSize"
        layout="prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import {listNews} from '../api/api';
  export default {
    props: {
      settings: {
        type: Object,
        default: function () {
          return {
            consultId: 32,
            publishState: 0,
            publishTime: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
            'displayPositionIds': [1, 3],
            'notProjectIds': [8, 9],
            'orderWeight': true,
            orderPublishTime: true,
            pageNum: 1,
            pageSize: 8
          }
        },
        validator: function (value) {
          let isValidator = true;
          return isValidator
        }
      }
    },
    components: {},
    data () {
      return {
        newsList: [],
        consultName: this.settings.consultName,
        pageNum: this.settings.pageNum,
        pageSize: this.settings.pageSize,
        total: 0
      }
    },
    mounted () {
      //this.settings.pageNum=1
      this.init();
    },
    computed: {},
    methods: {
      init(){
        listNews(this.settings).then((response) => {
          this.newsList = response.data.data.list;
          this.total = response.data.data.total;
        })
      },
      handleCurrentChange(val) {
        this.pageNum = val;
        this.settings.pageNum = val;
        this.init();
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/NewsSimpleList.vue